import { TYPES } from "../actions/templateAction.js";

const {
  API_REQUEST,
  API_ERROR,
  API_SUCCESS,
  CREATE_TEMPLATE_SUCCESS,
  LIST_TEMPLATE_SUCCESS,
  DELETE_TEMPLATE_SUCCESS,
  UPDATE_TEMPLATE_SUCCESS,
  SHARE_TEMPLATE_SUCCESS,
  CLEAR_ALERT,
} = TYPES;

const initialState = {
  loading: false,
  templates: [],
  error: false,
  msg: null,
};

const templateReducer = (state = initialState, action) => {
  switch (action.type) {
    case API_REQUEST: {
      return { ...state, loading: true };
    }

    case API_ERROR: {
      return {
        ...state,
        msg: action.msg,
        error: true,
        loading: false,
      };
    }

    case CLEAR_ALERT:
      return {
        ...state,
        error: false,
        msg: null,
      };

    case CREATE_TEMPLATE_SUCCESS: {
      return {
        ...state,
        templates: [
          { ...action.payload, isUserCreator: true },
          ...state.templates,
        ],
        loading: false,
        error: false,
        msg: "Template created successfully!!",
      };
    }

    case LIST_TEMPLATE_SUCCESS: {
      return {
        ...state,
        templates: action.payload,
        loading: false,
      };
    }

    case SHARE_TEMPLATE_SUCCESS:
        const allTemps = [...state.templates];
        const newTemps = allTemps.map((t) =>
          t._id === action.data.tId ? { ...t, sharedWith: action.data.sharedWithData} : t
        );
        return {
          ...state,
          templates: newTemps,
          msg: "Share Template is updated successfully!!",
        };

    case UPDATE_TEMPLATE_SUCCESS:
      const allTemp = [...state.templates];
      const newTemp = allTemp.map((t) =>
        t._id === action.data.tId ? { ...t, name: action.data.name } : t
      );
      return {
        ...state,
        templates: newTemp,
        msg: "Template updated successfully!!",
        error: false,
      };

    case DELETE_TEMPLATE_SUCCESS: {
      let templates = [...state.templates];
      return {
        ...state,
        templates: templates.filter(
          (template) => template._id !== action.payload
        ),
        loading: false,
        error: false,
        msg: "Template deleted successfully!!",
      };
    }

    case API_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        msg: action.msg || "Success",
      };

    default: {
      return { ...state };
    }
  }
};

export default templateReducer;
